import { SVGProps } from 'react';

export const CategoryTravel = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg {...props} width='186' height='225' viewBox='0 39 186 225' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clip-path='url(#clip0_151_5887)'>
      <g
        style={{
          mixBlendMode: 'multiply',
        }}
        opacity='0.3'
      >
        <ellipse cx='95.7642' cy='251.089' rx='93.4286' ry='10.5107' fill='#C4C4C4' />
      </g>
      <g clip-path='url(#clip1_151_5887)'>
        <path
          d='M113.228 140.446C141.269 140.446 164 117.714 164 89.6738C164 61.6334 141.269 38.9021 113.228 38.9021C85.1878 38.9021 62.4565 61.6334 62.4565 89.6738C62.4565 117.714 85.1878 140.446 113.228 140.446Z'
          fill='#FCBE12'
        />
        <path
          d='M40.0544 186.326C20.4891 186.326 4.73914 201.978 4.73914 221.348C4.73914 240.717 20.587 256.369 40.0544 256.369C59.6196 256.369 75.3696 240.717 75.3696 221.348C75.3696 201.978 59.6196 186.326 40.0544 186.326ZM40.0544 253.435C22.1522 253.435 7.67392 239.054 7.67392 221.348C7.67392 203.641 22.1522 189.261 40.0544 189.261C57.9565 189.261 72.4348 203.641 72.4348 221.348C72.4348 239.054 57.9565 253.435 40.0544 253.435Z'
          fill='#C6BEB7'
        />
        <path
          d='M40.0543 183.685C19.0217 183.685 2 200.511 2 221.348C2 242.185 19.0217 259.108 40.0543 259.108C61.087 259.108 78.1087 242.185 78.1087 221.445C78.1087 200.706 61.087 183.685 40.0543 183.685ZM40.0543 255.88C20.7826 255.88 5.22826 240.424 5.22826 221.348C5.22826 202.272 20.8804 186.815 40.0543 186.815C59.3261 186.815 74.8804 202.272 74.8804 221.348C74.8804 240.424 59.3261 255.88 40.0543 255.88Z'
          fill='#4C4C4C'
        />
        <path
          d='M40.0543 224.38C42.2695 224.38 44.0652 222.584 44.0652 220.369C44.0652 218.154 42.2695 216.358 40.0543 216.358C37.8392 216.358 36.0435 218.154 36.0435 220.369C36.0435 222.584 37.8392 224.38 40.0543 224.38Z'
          fill='#FF5E00'
        />
        <path
          d='M40.0543 222.13C39.7609 222.13 39.3696 222.032 39.0761 221.837C38.2935 221.347 38.0978 220.271 38.587 219.391L45.5326 209.021C45.5326 208.924 48.4674 204.619 49.837 198.847L57.8587 163.434C58.0543 162.456 59.0326 161.869 59.913 162.163C60.8913 162.358 61.4783 163.337 61.1848 164.217L53.163 199.63C51.5978 206.087 48.4674 210.782 48.2717 210.978L41.3261 221.347C41.2283 221.837 40.6413 222.13 40.0543 222.13Z'
          fill='#ADA9A3'
        />
        <path
          d='M116.554 176.543H57.5652C56.587 176.543 55.8044 175.761 55.8044 174.782C55.8044 173.804 56.587 173.021 57.5652 173.021H116.554C117.533 173.021 118.315 173.804 118.315 174.782C118.315 175.761 117.533 176.543 116.554 176.543Z'
          fill='#ADA9A3'
        />
        <path
          d='M103.152 236.315C108.717 236.315 113.228 231.804 113.228 226.239C113.228 220.674 108.717 216.163 103.152 216.163C97.5873 216.163 93.0761 220.674 93.0761 226.239C93.0761 231.804 97.5873 236.315 103.152 236.315Z'
          fill='#7C7C7C'
        />
        <path d='M58.8205 173.679L56.2567 175.948L101.774 227.371L104.338 225.102L58.8205 173.679Z' fill='#ADA9A3' />
        <path
          d='M149.815 186.326C130.25 186.326 114.5 201.978 114.5 221.348C114.5 240.717 130.348 256.369 149.815 256.369C169.38 256.369 185.13 240.717 185.13 221.348C185.13 201.978 169.38 186.326 149.815 186.326ZM149.815 253.435C131.913 253.435 117.435 239.054 117.435 221.348C117.435 203.641 131.913 189.261 149.815 189.261C167.717 189.261 182.196 203.641 182.196 221.348C182.196 239.054 167.717 253.435 149.815 253.435Z'
          fill='#C6BEB7'
        />
        <path
          d='M149.815 183.685C128.783 183.685 111.761 200.608 111.761 221.348C111.761 242.087 128.783 259.011 149.815 259.011C170.848 259.011 187.87 242.087 187.87 221.348C187.87 200.608 170.848 183.685 149.815 183.685ZM149.815 255.88C130.543 255.88 114.989 240.424 114.989 221.348C114.989 202.272 130.641 186.815 149.815 186.815C169.087 186.815 184.641 202.272 184.641 221.348C184.641 240.424 169.087 255.88 149.815 255.88Z'
          fill='#4C4C4C'
        />
        <path
          d='M61.1848 165.391C61.087 165.391 61.087 165.391 60.9891 165.391L53.5544 164.511C52.5761 164.413 51.8913 163.532 52.087 162.554C52.1848 161.576 53.0652 160.891 54.0435 161.087L61.4783 161.967C62.4565 162.065 63.1413 162.945 62.9457 163.924C62.75 164.706 62.0652 165.391 61.1848 165.391Z'
          fill='#ADA9A3'
        />
        <path d='M119.87 159.478L113.75 182.245L115.922 182.829L122.043 160.062L119.87 159.478Z' fill='#4C4C4C' />
        <path
          d='M103.152 228C102.957 228 102.859 228 102.663 227.902C101.783 227.608 101.196 226.728 101.391 225.75L115.87 171.652C116.163 170.772 117.043 170.185 118.022 170.38C118.902 170.674 119.489 171.554 119.293 172.532L104.815 226.63C104.62 227.413 103.837 228 103.152 228Z'
          fill='#ADA9A3'
        />
        <path
          d='M149.815 224.869C152.301 224.869 154.315 222.855 154.315 220.369C154.315 217.884 152.301 215.869 149.815 215.869C147.33 215.869 145.315 217.884 145.315 220.369C145.315 222.855 147.33 224.869 149.815 224.869Z'
          fill='#FF5E00'
        />
        <path
          d='M110.978 154.435H134.554L135.239 156.587L129.174 160.5C129.174 160.5 122.913 164.706 117.533 159.815C117.533 159.815 116.261 158.543 114.207 158.543H110.978V154.435Z'
          fill='#213C80'
        />
        <path
          d='M134.554 156.782C135.203 156.782 135.728 156.257 135.728 155.608C135.728 154.96 135.203 154.435 134.554 154.435C133.906 154.435 133.38 154.96 133.38 155.608C133.38 156.257 133.906 156.782 134.554 156.782Z'
          fill='#213C80'
        />
        <path
          d='M110.978 158.543C112.113 158.543 113.033 157.624 113.033 156.489C113.033 155.354 112.113 154.435 110.978 154.435C109.844 154.435 108.924 155.354 108.924 156.489C108.924 157.624 109.844 158.543 110.978 158.543Z'
          fill='#213C80'
        />
        <path
          d='M150.304 221.25C149.913 221.25 149.522 221.054 149.326 220.761L115.967 175.467C115.576 174.978 115.674 174.195 116.261 173.804C116.75 173.413 117.533 173.511 117.924 174.098L151.283 219.391C151.674 219.88 151.576 220.663 150.989 221.054C150.793 221.25 150.5 221.25 150.304 221.25Z'
          fill='#ADA9A3'
        />
        <path
          d='M103.152 228C102.272 228 101.587 227.315 101.391 226.435C101.293 225.456 101.978 224.576 102.859 224.478L149.62 218.608C150.598 218.511 151.478 219.195 151.576 220.076C151.674 221.054 150.989 221.935 150.109 222.032L103.348 227.902C103.25 227.902 103.152 228 103.152 228Z'
          fill='#ADA9A3'
        />
        <path
          d='M53.5544 164.413C48.6631 163.924 47.587 160.793 47.587 159.228V155.217H51.0109V159.326C51.0109 159.913 51.7935 160.696 53.8478 160.891L53.5544 164.413Z'
          fill='#4C4C4C'
        />
        <path
          d='M86.913 220.173L103.641 224.576C105.891 225.26 104.913 228.587 102.663 227.902L86.3261 222.423C84.8587 221.934 85.4456 219.782 86.913 220.173Z'
          fill='#ADA9A3'
        />
        <path
          d='M91.9022 219.098C92.0979 219.685 91.8044 220.272 91.2174 220.467L81.8261 223.793C81.2392 223.989 80.6522 223.696 80.4565 223.109C80.2609 222.522 80.5544 221.935 81.1413 221.739L90.5326 218.413C91.1196 218.217 91.7065 218.511 91.9022 219.098Z'
          fill='#7C7C7C'
        />
        <path
          d='M54.1413 147.88L45.8261 148.467C45.8261 148.467 43.8696 148.467 43.8696 150.815V154.826C43.8696 155.217 43.9674 155.902 44.6522 156.293L48.4674 159.13L47.2935 154.337C47.2935 154.337 47.1957 151.108 49.837 153.163L51.8913 157.076L54.8261 154.043C54.8261 154.043 56.587 152.38 56.3913 150.815L54.1413 147.88Z'
          fill='white'
        />
        <path
          d='M49.8658 158.897C49.9099 158.576 49.5985 158.267 49.1703 158.209C48.7421 158.15 48.3592 158.362 48.3151 158.684C48.271 159.005 48.5824 159.313 49.0106 159.372C49.4388 159.43 49.8217 159.218 49.8658 158.897Z'
          fill='white'
        />
        <path d='M46.9022 153.065C46.9022 153.065 48.0761 149.935 50.7174 152.38L46.9022 153.065Z' fill='#E3DFDA' />
        <path
          d='M49.3478 158.641C51.1848 158.641 52.6739 157.152 52.6739 155.315C52.6739 153.478 51.1848 151.989 49.3478 151.989C47.5109 151.989 46.0217 153.478 46.0217 155.315C46.0217 157.152 47.5109 158.641 49.3478 158.641Z'
          fill='#C6BEB7'
        />
        <path
          d='M49.3478 157.956C50.8066 157.956 51.9891 156.774 51.9891 155.315C51.9891 153.856 50.8066 152.674 49.3478 152.674C47.8891 152.674 46.7065 153.856 46.7065 155.315C46.7065 156.774 47.8891 157.956 49.3478 157.956Z'
          fill='#ADA9A3'
        />
        <path d='M87.5 246.88L87.8913 255.391L92.3913 257.935L98.2609 254.022V248.739L87.5 246.88Z' fill='#E3DFDA' />
        <path
          d='M98.75 170.38L82.3152 175.467L82.9022 142.011L82.6087 128.022C82.6087 128.022 81.9239 106.5 86.913 103.369L98.75 170.38Z'
          fill='#FF5E00'
        />
        <path d='M64.5109 143.282L53.2609 148.272L55.3152 152.478L66.663 148.859L64.5109 143.282Z' fill='white' />
        <path
          d='M61.6784 154.861C62.3803 154.579 62.1163 152.277 61.0888 149.721C60.0613 147.164 58.6594 145.32 57.9575 145.602C57.2557 145.884 57.5197 148.185 58.5472 150.742C59.5746 153.299 60.9766 155.143 61.6784 154.861Z'
          fill='#FF5E00'
        />
        <path d='M85.1522 133.109L57.9565 145.63L61.5761 154.826L84.9565 147.587L85.1522 133.109Z' fill='#FF5E00' />
        <path d='M81.0435 137.022L83.8804 110.12L86.6195 132.13L81.0435 137.022Z' fill='#FF5E00' />
        <path
          d='M90.0434 105.815L88.8695 96.6194L84.3695 101.217C84.0761 101.511 83.1956 102.685 83.6848 104.641L86.7174 116.282L90.0434 105.815Z'
          fill='#4C4C4C'
        />
        <path d='M99.4348 88.989L97.7717 89.0868L98.75 90.7499L99.4348 88.989Z' fill='#4C4C4C' />
        <path
          d='M96.3044 84.3911L99.6304 92.2172L88.9674 101.804L86.1304 96.7172C86.1304 96.7172 84.4674 94.0759 85.0544 91.4346L96.3044 84.3911Z'
          fill='#E3DFDA'
        />
        <path d='M117.141 151.598L126.826 145.63L115.185 140.152L117.141 151.598Z' fill='#7C7C7C' />
        <path
          d='M128.391 127.533C128.391 127.533 131.033 126.261 129.761 122.641L123.989 106.206C123.989 106.206 121.935 99.8478 120.859 106.206L118.413 131.739L128.391 127.533Z'
          fill='#7C7C7C'
        />
        <path
          d='M120.565 109.043L127.609 139.565C127.609 139.565 129.565 145.924 125.261 146.022L120.37 146.12C120.37 146.12 116.261 146.511 116.946 140.641L120.565 109.043Z'
          fill='white'
        />
        <path
          d='M120.957 106.206C121.25 104.348 121.641 103.565 122.033 103.467L114.109 104.837L116.946 141.619L120.957 106.206Z'
          fill='#4C4C4C'
        />
        <path
          d='M85.6413 172.63C85.6413 172.63 85.9348 200.511 86.1304 209.609C86.3261 219.196 87.1087 248.641 87.1087 248.641H87.2065V248.739C87.1087 249.619 90.2391 250.598 94.1522 250.891C98.0652 251.185 101.196 250.598 101.293 249.717C101.293 249.619 101.293 249.619 101.293 249.522L105.109 195.522L110.196 189.261C117.728 181.043 119.293 170.282 119.293 170.282L85.6413 172.63Z'
          fill='#4C4C4C'
        />
        <path
          d='M132.989 239.935L138.272 245.609L148.446 243.946L147.467 239.935L140.815 232.793L132.989 239.935Z'
          fill='white'
        />
        <path d='M138.272 245.609L140.913 245.119L143.065 235.239L133.87 240.913L138.272 245.609Z' fill='#E3DFDA' />
        <path
          d='M87.4022 101.902C87.4022 101.902 86.3261 102.88 86.3261 105.815C86.2283 108.359 84.3696 176.641 84.3696 176.641L122.522 169.011L118.12 139.467L116.163 113.348L110.978 98.3805L101.196 92.7065L87.4022 101.902Z'
          fill='#FF5E00'
        />
        <path
          d='M104.033 166.761C92.4891 168.326 82.413 172.141 82.3152 175.565C82.3152 178.793 92.6848 179.478 104.228 177.424C114.793 175.467 122.522 171.848 122.522 169.206C122.522 166.467 114.598 165.293 104.033 166.761Z'
          fill='#FF5E00'
        />
        <path
          d='M97.3804 112.174C97.1848 103.467 101.293 96.3259 106.478 96.2281C111.37 96.1303 115.576 102.391 116.163 110.413C116.163 110.315 116.163 110.315 116.163 110.217C115.967 101.706 110.978 94.8585 105.109 94.9564C99.1413 95.0542 94.4457 102.098 94.6413 110.706C94.7391 117.261 97.6739 122.739 101.685 124.891C99.1413 122.152 97.4783 117.456 97.3804 112.174Z'
          fill='#FCBE12'
        />
        <path
          d='M116.261 111.391C116.457 119.511 112.348 126.163 107.163 126.261C101.978 126.359 97.6739 119.902 97.4783 111.783C97.2826 103.663 101.391 96.9131 106.576 96.9131C112.641 97.0109 116.065 103.272 116.261 111.391Z'
          fill='#FF5E00'
        />
        <path
          d='M101.196 261.359L100.12 252.848C100.12 252.848 100.12 252.848 100.12 252.75C100.022 252.261 99.6305 251.967 99.1413 251.967C98.8479 251.967 98.5544 252.163 98.3587 252.359C98.2609 252.456 98.2609 252.554 98.1631 252.75C97.7718 254.902 95.5218 256.174 92.7826 255.587C90.4348 255.098 88.4783 253.435 87.6957 251.478V251.38C87.5 250.891 87.0109 250.598 86.4239 250.598C86.1305 250.598 85.837 250.695 85.6413 250.793C85.5435 250.891 85.5435 250.891 85.5435 250.891L85.4457 250.989L77.9131 256.761C75.9565 258.228 73.4131 258.619 73.4131 258.619L69.7935 259.109C69.6957 259.109 69.5 259.109 69.4022 259.109H69.3044C68.1305 259.402 67.1522 260.185 67.1522 261.065C67.1522 261.261 67.25 261.456 67.25 261.652C67.25 261.652 67.25 261.75 67.3478 261.75C67.3478 261.848 67.4457 261.945 67.4457 262.043C68.7174 264.098 71.4565 264.098 71.4565 264.098H97.3805C101.685 264.098 101.196 261.359 101.196 261.359Z'
          fill='#FF5E00'
        />
        <path
          d='M152.848 240.717L148.152 237.391C147.957 237.293 147.761 237.196 147.565 237.196C146.978 237.196 146.587 237.587 146.587 238.174C146.587 238.369 146.587 238.467 146.685 238.565C146.978 239.054 147.076 239.641 147.076 240.228C147.076 242.772 144.043 244.728 140.424 244.533C138.663 244.435 137 243.848 135.826 242.967H135.728L133.478 253.826C133.478 253.826 132.989 256.467 130.837 257.837L128.293 259.206L127.804 259.5C126.924 260.185 126.337 260.772 126.435 261.652C126.435 261.946 126.533 262.141 126.63 262.337C126.826 262.63 127.022 262.826 127.315 263.022C127.902 263.413 128.783 263.511 129.663 263.217L130.054 263.119L137.783 261.065C137.783 261.065 142.38 259.402 145.511 256.272L154.217 247.565C154.12 247.565 157.641 244.141 152.848 240.717Z'
          fill='#FF5E00'
        />
        <path
          d='M107.065 181.239L105.891 179.772C105.891 179.772 104.913 178.402 105.402 176.544C105.402 176.544 106.185 172.826 105.5 169.207C104.815 165.587 105.207 162.457 105.402 161.283L98.3587 164.217L95.6196 174C95.5217 174.489 95.4239 175.076 95.4239 175.565L95.7174 181.826C95.7174 181.826 95.8152 183 96.5 183.587L98.8478 184.859C98.8478 184.859 99.9239 185.446 100.609 184.957C100.707 184.859 100.804 184.663 100.804 184.467H100.902C100.902 184.467 102.37 185.25 103.446 183.783C103.543 183.685 103.543 183.587 103.641 183.587L104.228 183.783C104.228 183.783 106.087 184.467 106.38 182.804C106.674 182.902 107.163 183 107.554 182.609C107.75 182.12 107.457 181.631 107.065 181.239Z'
          fill='white'
        />
        <path
          d='M89.6522 64.8259C88.9674 64.8259 88.3805 64.9238 87.7935 65.0216L81.7283 65.6085C81.6305 65.6085 81.5326 65.6085 81.4348 65.6085C78.8913 65.6085 76.837 67.6629 76.837 70.2064C76.837 71.5759 77.5218 72.8477 78.5 73.7281C78.5 73.8259 78.5978 73.8259 78.5978 73.9238L78.6957 73.8259C78.8913 74.0216 79.1848 74.1194 79.4783 74.3151C79.4783 74.6085 79.4783 74.902 79.4783 75.1955C79.4783 80.8694 84.0761 85.4672 89.75 85.4672C95.4239 85.4672 100.022 80.8694 100.022 75.1955C99.9239 69.4238 95.3261 64.8259 89.6522 64.8259Z'
          fill='#4C4C4C'
        />
        <path
          d='M88.4783 87.1304C94.1512 87.1304 98.75 82.5316 98.75 76.8587C98.75 71.1857 94.1512 66.5869 88.4783 66.5869C82.8053 66.5869 78.2065 71.1857 78.2065 76.8587C78.2065 82.5316 82.8053 87.1304 88.4783 87.1304Z'
          fill='white'
        />
        <path
          d='M96.6957 81.652L96.5978 80.5759L78.8913 73.1411L77.3261 76.9563C77.2283 77.0542 77.1304 77.6411 77.3261 78.2281L77.6196 78.9129C77.6196 78.9129 77.9131 79.5976 77.7174 80.2824L77.4239 81.7498C77.4239 81.7498 76.837 84.5868 77.913 86.7389L80.5544 91.8259C80.5544 91.8259 82.7065 96.7172 91.9022 90.652C91.9022 90.652 97.4783 87.0324 96.6957 81.652Z'
          fill='white'
        />
        <path
          d='M91.5109 73.5325C91.5109 73.5325 91.5109 73.826 91.8044 73.9238H91.2174L91.5109 73.5325Z'
          fill='white'
        />
        <path
          d='M96.7935 69.1304C96.7935 69.1304 94.1522 65.9021 89.5543 65.9021L81.9239 66.3912L79.7717 71.3804C80.3587 70.4021 81.1413 70.2064 81.1413 70.2064C83.5869 70.0108 87.5 69.7173 87.5 69.7173C88.0869 69.7173 88.5761 69.8151 89.163 70.0108C90.7282 70.5978 91.6087 72.163 91.5109 73.7282C91.9022 73.826 93.4674 74.413 93.3696 77.4456V81.3586L94.9348 81.4564V80.576C94.9348 80.4782 95.0326 80.1847 95.1304 79.9891C95.5217 78.913 96.6956 78.4238 97.7717 78.8151C98.163 79.0108 98.4565 79.3043 98.6522 79.5978C99.1413 78.2282 100.609 71.8695 96.7935 69.1304Z'
          fill='#4C4C4C'
        />
        <path
          d='M93.4674 81.2607C93.4674 81.2607 93.4674 81.5542 93.663 81.5542L93.2717 81.7499L93.4674 81.2607Z'
          fill='white'
        />
        <path
          d='M99.0435 89.2824L87.4022 101.902L91.2174 106.011L101.783 92.7063L100.511 89.9671C100.609 89.9671 100.022 88.3041 99.0435 89.2824Z'
          fill='#ADA9A3'
        />
        <path
          d='M90.337 105.13C90.337 105.13 91.1196 106.206 92.1957 104.837L92.587 105.815L90.6304 106.695C90.7283 106.695 90.0435 105.815 90.337 105.13Z'
          fill='#FF5E00'
        />
        <path
          d='M116.652 130.076L116.261 111.391L97.5761 111.783L99.5326 136.924L96.1087 164.707C96.1087 165.587 99.6304 165.685 103.837 164.902C108.141 164.12 111.565 162.848 111.565 161.967L115.087 146.413C116.75 138.978 116.652 130.076 116.652 130.076Z'
          fill='#FF5E00'
        />
        <path
          d='M143.065 234.457C132.011 219.489 124.38 208.533 124.38 208.533C120.076 202.467 118.315 194.446 118.315 194.446L114.5 175.957L102.565 190.728L101.098 208.239C103.152 210.196 132.109 243.457 132.109 243.457C132.793 244.337 135.826 242.967 138.859 240.522C141.793 238.076 143.554 235.435 143.065 234.457Z'
          fill='#4C4C4C'
        />
        <path
          d='M82.0217 131.739C82.0217 131.739 84.0761 130.761 84.0761 127.728L85.6413 131.25L82.0217 131.739Z'
          fill='#FF5E00'
        />
        <path
          d='M62.1631 259.011H24.8913C24.5 259.011 24.2065 258.717 24.2065 258.326C24.2065 257.935 24.5 257.641 24.8913 257.641H62.1631C62.5544 257.641 62.8478 257.935 62.8478 258.326C62.8478 258.717 62.5544 259.011 62.1631 259.011Z'
          fill='#4C4C4C'
        />
        <path
          d='M171.924 259.011H150.402C150.011 259.011 149.717 258.717 149.717 258.326C149.717 257.935 150.011 257.641 150.402 257.641H171.924C172.315 257.641 172.609 257.935 172.609 258.326C172.609 258.717 172.315 259.011 171.924 259.011Z'
          fill='#4C4C4C'
        />
        <path
          d='M95.3261 79.6955C95.3261 79.6955 96.7935 77.3477 98.6522 79.3042C100.315 81.0651 96.3044 87.9129 94.7391 85.0759L95.3261 79.6955Z'
          fill='white'
        />
      </g>
    </g>
    <defs>
      <clipPath id='clip0_151_5887'>
        <rect width='190.361' height='261.6' fill='white' transform='matrix(-1 0 0 1 190.361 0)' />
      </clipPath>
      <clipPath id='clip1_151_5887'>
        <rect width='185.87' height='225' fill='white' transform='translate(2 39)' />
      </clipPath>
    </defs>
  </svg>
);
